import {
      GET_INVESTMENT_HOLDING_FTC_CALCULATION,
      POST_INVESTMENT_HOLDING_FTC_CALCULATION,
      PUT_INVESTMENT_HOLDING_FTC_CALCULATION
    } from "../constants/actionTypes";

    const defaultState = {
      ftcComputationArr: [],
      ftcComputation: {}
    };

    let data=[]
    export default (state = defaultState, action) => {
      try {
        switch (action.type) {
          case GET_INVESTMENT_HOLDING_FTC_CALCULATION:
            if (Array.isArray(action.payload)) {
              return {...state, ftcComputationArr: [...action.payload]};
            }
            return {...state, ftcComputation: {...action.payload}};
          case POST_INVESTMENT_HOLDING_FTC_CALCULATION:
            return {...state, ftcComputationArr: [...state?.ftcComputationArr, action.payload]};
          case PUT_INVESTMENT_HOLDING_FTC_CALCULATION:
            data = [...state?.ftcComputationArr];
            const index = data?.findIndex(
              (ftc) => ftc?.id === action.payload?.id,
            );
            if (index != -1) data[index] = { ...action?.payload };
            return {...state, ftcComputationArr: [...data], ftcComputation: {...action.payload}};
          default:
            return state;
        }
      } catch (error) {
        throw new Error(error);
      }
    };